namespace Recommendations  {

    function Bd4Helper (
        bd4t,
        $q: ng.IQService,
        $http: ng.IHttpService
    )
    {
        let getUserId = _.memoize(function() {
            const def = $q.defer();
            bd4t('get', 'config', cfg => def.resolve(cfg && cfg.userId));
            return def.promise;
        });

        function getRecommendedDestinations(placementId, context, currentDestination, limit: number)
            : ng.IPromise<Bd4Destination[]> {

            let bd4 = TRPCONFIG.Domain.BD4TrackingId;
            return getUserId()
                .then(userId => ({
                    userId,
                    limit,
                    placementId,
                    context
                }))
                .then(options => $http.post(
                    `https://api1.bd4travel.com/recommender/${bd4}/v3/categories/tr${currentDestination.Type}`,
                    options,
                    {ignoreErrors: true}
                ))
                .then(response => {
                    let elements: any = _.get(response, 'data.elements');
                    let destinations = _.map(elements, Bd4Destination);
                    if (destinations && destinations.length) {
                        return destinations;
                    } else {
                        return $q.reject('no destinations');
                    }
                });
        }

        function getRecommendations(
            placementId, limit: number, context = {}, destinationsFilter: Bd4Destination[]): ng.IPromise<any> {

            let options: any = {
                limit,
                placementId,
                context,
            };

            if (destinationsFilter) {
                options.query = {
                    categories: _.map(destinationsFilter, d => ({type: 'tr' + d.Type, id: d.Id}))
                };
            }

            return getUserId()
                .then(userId => options.userId = userId)
                .then(() => $http.post(
                    `https://api1.bd4travel.com/recommender/${TRPCONFIG.Domain.BD4TrackingId}/v3`,
                    options,
                    { ignoreErrors: true }
                ))
                .then(response => {
                    let elements: any = _.get(response, 'data.elements');
                    let estabIds = _.map(elements, (e: any)  => e.object.id);
                    if (estabIds && estabIds.length) {
                        return {
                            estabIds,
                            ptoken: _(response).get('data.ptoken')
                        };
                    } else {
                        return $q.reject('no estabIds');
                    }
                });
        }

        return {
            getUserId,
            getRecommendedDestinations,
            getRecommendations
        };
    }

    angular
        .module('recommendations')
        .service('bd4Helper', Bd4Helper);
}
